import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SITE_URL = 'https://zpacestudio.com'

const pageMetadata = {
  '/': {
    title: 'Zpace Studio — Thoughtful Digital Spaces',
    description:
      'Zpace Studio creates thoughtful digital tools, playful web experiences, and carefully managed member applications.',
    socialTitle: 'Zpace Studio',
    socialDescription: 'Useful digital spaces, thoughtfully made.',
    type: 'website',
  },
  '/privacy/': {
    title: 'Privacy Library — Zpace Studio',
    description: 'Privacy policies for Zpace Studio products and the Edgezpace website.',
    socialTitle: 'Privacy Library — Zpace Studio',
    socialDescription: 'Clear privacy information for Zpace Studio and Edgezpace.',
    type: 'website',
  },
  '/about/': {
    title: 'About — Zpace Studio',
    description:
      'Learn about the focus, tools, technologies, and creative interests behind Zpace Studio.',
    socialTitle: 'About — Zpace Studio',
    socialDescription: 'Thoughtful systems and useful digital experiences with a visual foundation.',
    type: 'website',
  },
  '/privacy/edgezpace/': {
    title: 'Edgezpace Website Privacy Policy — Zpace Studio',
    description: 'Edgezpace Website Privacy Policy.',
    socialTitle: 'Edgezpace Website Privacy Policy',
    socialDescription: 'How the Edgezpace portfolio website handles information.',
    type: 'article',
  },
  '/privacy/academic-edge/': {
    title: 'Academic Edge Privacy Policy — Zpace Studio',
    description: 'Academic Edge Privacy Policy from Zpace Studio.',
    socialTitle: 'Academic Edge Privacy Policy',
    socialDescription:
      'How Academic Edge handles account, planning, calendar, file, and AI-assisted feature information.',
    type: 'article',
  },
}

function normalizedPath(pathname) {
  if (pathname === '/') return '/'
  return `${pathname.replace(/\/+$/, '')}/`
}

function setMeta(selector, attribute, value) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    const match = selector.match(/meta\[(name|property)="([^"]+)"\]/)
    if (!match) return
    element.setAttribute(match[1], match[2])
    document.head.append(element)
  }
  element.setAttribute(attribute, value)
}

export default function SeoManager() {
  const { pathname } = useLocation()

  useEffect(() => {
    const path = normalizedPath(pathname)
    const metadata = pageMetadata[path] ?? {
      title: 'Page Not Found — Zpace Studio',
      description: 'The requested page could not be found.',
      socialTitle: 'Page Not Found — Zpace Studio',
      socialDescription: 'Return to the Zpace Studio home page.',
      type: 'website',
    }
    const canonicalUrl = pageMetadata[path] ? `${SITE_URL}${path === '/' ? '/' : path}` : SITE_URL
    const canonical = document.head.querySelector('link[rel="canonical"]')

    document.title = metadata.title
    canonical?.setAttribute('href', canonicalUrl)
    setMeta('meta[name="description"]', 'content', metadata.description)
    setMeta('meta[name="robots"]', 'content', pageMetadata[path] ? 'index, follow' : 'noindex')
    setMeta('meta[property="og:title"]', 'content', metadata.socialTitle)
    setMeta('meta[property="og:description"]', 'content', metadata.socialDescription)
    setMeta('meta[property="og:type"]', 'content', metadata.type)
    setMeta('meta[property="og:url"]', 'content', canonicalUrl)
  }, [pathname])

  return null
}
